<!--
  Component: Home
  Description: Displays the text explaining how the use the musiscope, 
               also renders the actual Musiscope Component
-->
<template>
  <div class="home">
    <musiscope />
    <p>
      To start, click "start". "stop" to stop recording. "clear" to clear the current recording.
      "play clip" will play the whole recording.
    </p>
    <p>
      Scroll up and down on the oscilloscope viewer to zoom in and out on the waveform, and the time
      scale is shown at the bottom. You can alternately use the +/- buttons to zoom.
    </p>
    <p>Scroll left and right on the viewer to scroll the data, or use the arrow buttons.</p>
    <p>
      Enable "lock wave" to make the viewing window attempt to lock onto a waveform preventing it
      from sliding across the window.
    </p>
    <p>
      Click and drag on the viewer to select a portion of the waveform. You can play the selection
      or loop it for 1 second by clicking the "play" or "loop 1s" buttons under the selection
      section. "loop" will loop the selection indefinitely.
    </p>
    <p>Enjoy! :D</p>
  </div>
</template>

<script>
import Musiscope from '@/components/Musiscope.vue'

export default {
  components: { Musiscope }
}
</script>
